module.exports = __webpack_public_path__ + "img/Steor-Icons-04.ddc511f6.svg";